import React from "react";
import { FiX, FiPlus, FiTrash2 } from "react-icons/fi";

const stages = [
    { value: 1, label: "۱ — مراجعه‌کننده" },
    { value: 2, label: "۲ — علاقه‌مند به محصول" },
    { value: 3, label: "۳ — علاقه‌مند به خرید" },
    { value: 4, label: "۴ — مشتری" },
    { value: 5, label: "۵ — مشتری وفادار" },
    { value: 6, label: "۶ — مشتری ناراضی" },
];

const ruleFields = [
    { value: "messageCount", label: "تعداد پیام‌ها (messageCount)" },
    {
        value: "daysSinceLastActivity",
        label: "روز از آخرین فعالیت (daysSinceLastActivity)",
    },
    {
        value: "chatroomCount",
        label: "تعداد چت‌روم‌ها (chatroomCount)",
    },
    {
        value: "daysSinceFirstContact",
        label: "روز از اولین تماس (daysSinceFirstContact)",
    },
];

const operators = [
    { label: "< (کوچکتر)", value: "<" },
    { label: "<= (کوچکتر مساوی)", value: "<=" },
    { label: "== (مساوی)", value: "==" },
    { label: ">= (بزرگتر مساوی)", value: ">=" },
    { label: "> (بزرگتر)", value: ">" },
];

const EditCriterionModal = ({
    isOpen,
    onClose,
    criterion,

    title,
    setTitle,

    description,
    setDescription,

    stageOrder,
    setStageOrder,

    prompt,
    setPrompt,

    // جدید
    conditions,
    setConditions,

    onUpdateDescription,
    onUpdatePrompt,
    onUpdateRule,

    isUpdating,
    error,
    successMessage,
}) => {
    if (!isOpen || !criterion) return null;

    const isAI = criterion.type === "AI";
    const isRule = criterion.type === "SYSTEM_RULE";

    const handleConditionChange = (index, key, value) => {
        setConditions((prev) =>
            prev.map((condition, i) =>
                i === index
                    ? {
                        ...condition,
                        [key]: value,
                    }
                    : condition
            )
        );
    };

    const handleConditionValueChange = (index, value) => {
        // فقط عدد صحیح غیرمنفی
        if (value !== "" && !/^\d+$/.test(value)) {
            return;
        }

        setConditions((prev) =>
            prev.map((condition, i) =>
                i === index
                    ? {
                        ...condition,
                        value,
                    }
                    : condition
            )
        );
    };

    const addCondition = () => {
        setConditions((prev) => [
            ...prev,
            {
                field: "messageCount",
                operator: "<",
                value: "",
            },
        ]);
    };

    const removeCondition = (index) => {
        // حداقل یک شرط باقی بماند
        if (conditions.length <= 1) return;

        setConditions((prev) =>
            prev.filter((_, i) => i !== index)
        );
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
            <div className="relative max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-2xl bg-white shadow-2xl">

                {/* Header */}
                <div className="sticky top-0 z-10 flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4">
                    <h3 className="text-xl font-bold text-[#173B3A]">
                        ویرایش معیار
                    </h3>

                    <button
                        onClick={onClose}
                        className="rounded-lg p-1.5 text-gray-400 transition hover:bg-gray-100 hover:text-gray-600"
                    >
                        <FiX size={20} />
                    </button>
                </div>

                {/* Body */}
                <div className="space-y-4 p-6">

                    {/* Title */}
                    <div>
                        <label className="mb-2 block text-sm font-semibold text-gray-700">
                            عنوان معیار
                        </label>

                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-500/10"
                        />
                    </div>

                    {/* Description */}
                    <div>
                        <label className="mb-2 block text-sm font-semibold text-gray-700">
                            توضیح داخلی
                        </label>

                        <input
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-500/10"
                        />
                    </div>

                    {/* Stage Order */}
                    <div>
                        <label className="mb-2 block text-sm font-semibold text-gray-700">
                            دسته (stageOrder)
                        </label>

                        <select
                            value={stageOrder}
                            onChange={(e) =>
                                setStageOrder(Number(e.target.value))
                            }
                            disabled={true}
                            className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-500/10 disabled:cursor-not-allowed disabled:bg-gray-100"
                        >
                            {stages.map((stage) => (
                                <option
                                    key={stage.value}
                                    value={stage.value}
                                >
                                    {stage.label}
                                </option>
                            ))}
                        </select>

                        <p className="mt-1 text-xs text-amber-600">
                            تغییر دسته ممکن نیست.
                        </p>
                    </div>

                    {/* AI Prompt */}
                    {isAI && (
                        <div>
                            <label className="mb-2 block text-sm font-semibold text-gray-700">
                                Prompt

                                <span className="mr-1 text-xs text-amber-600">
                                    (تغییر این مقدار باعث تحلیل مجدد کسب‌وکارها می‌شود)
                                </span>
                            </label>

                            <textarea
                                rows={4}
                                value={prompt}
                                onChange={(e) =>
                                    setPrompt(e.target.value)
                                }
                                className="w-full resize-y rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-500/10"
                            />
                        </div>
                    )}

                    {/* SYSTEM RULE */}
                    {isRule && (
                        <div>
                            <div className="mb-3 flex items-center justify-between">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700">
                                        قوانین شرطی
                                    </label>

                                    <p className="mt-1 text-xs text-gray-400">
                                        تمام شرط‌ها باید برقرار باشند.
                                    </p>
                                </div>
                            </div>

                            <div className="space-y-3">

                                {conditions.map((condition, index) => (
                                    <React.Fragment key={index}>

                                        {/* AND */}
                                        {index > 0 && (
                                            <div className="flex items-center justify-center">
                                                <span className="rounded-full bg-gray-100 px-4 py-1 text-xs font-bold text-gray-500">
                                                    و
                                                </span>
                                            </div>
                                        )}

                                        {/* Condition */}
                                        <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-3">

                                            <div className="mb-2 flex items-center justify-between">
                                                <span className="text-xs font-semibold text-gray-500">
                                                    شرط {index + 1}
                                                </span>

                                                {conditions.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            removeCondition(index)
                                                        }
                                                        className="flex items-center gap-1 rounded-lg px-2 py-1 text-xs text-red-500 transition hover:bg-red-50"
                                                    >
                                                        <FiTrash2 size={14} />
                                                        حذف
                                                    </button>
                                                )}
                                            </div>

                                            <div className="grid grid-cols-1 gap-3 md:grid-cols-3">

                                                {/* Field */}
                                                <div>
                                                    <label className="mb-2 block text-xs font-semibold text-gray-600">
                                                        فیلد
                                                    </label>

                                                    <select
                                                        value={condition.field}
                                                        onChange={(e) =>
                                                            handleConditionChange(
                                                                index,
                                                                "field",
                                                                e.target.value
                                                            )
                                                        }
                                                        className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-500/10"
                                                    >
                                                        {ruleFields.map(
                                                            (field) => (
                                                                <option
                                                                    key={field.value}
                                                                    value={field.value}
                                                                >
                                                                    {field.label}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>

                                                {/* Operator */}
                                                <div>
                                                    <label className="mb-2 block text-xs font-semibold text-gray-600">
                                                        عملگر
                                                    </label>

                                                    <select
                                                        value={condition.operator}
                                                        onChange={(e) =>
                                                            handleConditionChange(
                                                                index,
                                                                "operator",
                                                                e.target.value
                                                            )
                                                        }
                                                        className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-500/10"
                                                    >
                                                        {operators.map(
                                                            (item) => (
                                                                <option
                                                                    key={item.value}
                                                                    value={item.value}
                                                                >
                                                                    {item.label}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>

                                                {/* Value */}
                                                <div>
                                                    <label className="mb-2 block text-xs font-semibold text-gray-600">
                                                        مقدار
                                                    </label>

                                                    <input
                                                        type="text"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        value={condition.value ?? ""}
                                                        onChange={(e) =>
                                                            handleConditionValueChange(
                                                                index,
                                                                e.target.value
                                                            )
                                                        }
                                                        placeholder="مثلاً 20"
                                                        className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm outline-none transition placeholder:text-gray-400 focus:border-teal-500 focus:ring-2 focus:ring-teal-500/10"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>

                            {/* Add Condition */}
                            <button
                                type="button"
                                onClick={addCondition}
                                className="mt-3 inline-flex items-center gap-2 rounded-lg border border-teal-200 bg-teal-50 px-4 py-2 text-sm font-medium text-teal-700 transition hover:border-teal-300 hover:bg-teal-100"
                            >
                                <FiPlus size={16} />
                                افزودن شرط
                            </button>
                        </div>
                    )}

                    {/* Error */}
                    {error && (
                        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                            {error}
                        </div>
                    )}

                    {/* Success */}
                    {successMessage && (
                        <div className="rounded-xl border border-teal-200 bg-teal-50 px-4 py-3 text-sm text-teal-700">
                            {successMessage}
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div className="flex gap-3 border-t border-gray-100 pt-4">

                        <button
                            onClick={onClose}
                            className="rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-50"
                        >
                            انصراف
                        </button>

                        {isAI && (
                            <button
                                onClick={onUpdatePrompt}
                                disabled={isUpdating}
                                className="flex-1 rounded-lg bg-teal-700 px-4 py-2 text-sm font-medium text-white transition hover:bg-teal-800 disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                {isUpdating
                                    ? "در حال به‌روزرسانی..."
                                    : "به‌روزرسانی Prompt"}
                            </button>
                        )}

                        {isRule && (
                            <button
                                onClick={onUpdateRule}
                                disabled={isUpdating}
                                className="flex-1 rounded-lg bg-teal-700 px-4 py-2 text-sm font-medium text-white transition hover:bg-teal-800 disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                {isUpdating
                                    ? "در حال به‌روزرسانی..."
                                    : "به‌روزرسانی قوانین"}
                            </button>
                        )}

                        {!isAI && !isRule && (
                            <button
                                onClick={onUpdateDescription}
                                disabled={isUpdating}
                                className="flex-1 rounded-lg bg-teal-700 px-4 py-2 text-sm font-medium text-white transition hover:bg-teal-800 disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                {isUpdating
                                    ? "در حال به‌روزرسانی..."
                                    : "ذخیره تغییرات"}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditCriterionModal;
